import { Button } from "@mui/material";
import GlobalIcon from "../GlobalIcon/GlobalIcon";

function BookAddMoreSqOffButtons({
  buttonClassName,
  onAddMore,
  onSqOff,
  addMoreDisabled = false,
  sqOffDisabled = false,
}) {
  return (
    <>
      <Button
        variant="outlined"
        className={buttonClassName}
        onClick={onAddMore}
        disabled={addMoreDisabled}
        startIcon={<GlobalIcon iconName="AddIcon" />}
      >
        Add More
      </Button>
      <Button
        variant="outlined"
        className={buttonClassName}
        onClick={onSqOff}
        disabled={sqOffDisabled}
        startIcon={<GlobalIcon iconName="RefreshIcon" />}
      >
        SQ OFF
      </Button>
    </>
  );
}

export default BookAddMoreSqOffButtons;
